import axios from 'axios';
import { TAddFolderForm } from '../types/cloudStorage/CloudFileList';
import { PictureListPage } from '../pages/PictureListPage';

/**
 * 資料フォルダ一覧取得のapi
 */
export const getFileFolder = (param?: string) => {
  let url = '/api/v1/file-folders';
  if (param) {
    url += '?' + param;
  }
  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 検索値に合致するファイル一覧取得
 * @param param
 */
export const getSearchedFileList = (param?: string) => {
  let url = `/api/v1/files?`;
  if (param) {
    url += param;
  }

  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * フォルダに紐づくファイル一覧取得
 * @param folderId
 */
export const getFileList = (folderId: number, param?: string) => {
  let url = `/api/v1/files?folder_id=${folderId}`;
  if (param) {
    url += '&' + param;
  }

  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createFolder = (data: any) => {
  return axios
    .post('/api/v1/create-folder/files', data, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteFolder = async (folderId: number) => {
  return axios
    .post(`/api/v1/delete-folder/files/${folderId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真フォルダ一覧取得のapi
 */
export const getPictureFolder = (param?: string) => {
  let url = '/api/v1/picture-folders';
  if (param) {
    url += '?' + param;
  }
  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 検索値に合致する写真一覧取得
 */
export const getSearchedPictureList = (param?: string) => {
  let url = '/api/v1/pictures?';
  if (param) {
    url += param;
  }
  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
/**
 * フォルダに紐づく写真一覧取得
 * @param folderId
 */
export const getPictureList = (folderId: number, param?: string) => {
  let url = `/api/v1/pictures?folder_id=${folderId}`;
  if (param) {
    url += '&' + param;
  }

  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createPictureFolder = (data: any) => {
  return axios
    .post('/api/v1/create-folder/pictures', data, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deletePictureFolder = async (folderId: number) => {
  return axios
    .post(`/api/v1/delete-folder/pictures/${folderId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getThumbnail = (pictureId: number) => {
  return axios
    .get(`/api/v1/get/picture/thumbnail/${pictureId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 資料詳細取得のAPI
 */
export const getFileDetail = (fileId: number) => {
  const url = `/api/v1/file/${fileId}`;
  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 資料削除のAPI
 */
export const deleteFile = (fileId: number) => {
  const url = `/api/v1/delete/file/${fileId}`;
  return axios
    .post(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真詳細取得のAPI
 */
export const getPictureDetail = (pictureId: number) => {
  const url = `/api/v1/picture/${pictureId}`;
  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真削除のAPI
 */
export const deletePicture = (pictureId: number) => {
  const url = `/api/v1/delete/picture/${pictureId}`;
  return axios
    .post(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * ファイルのzipダウンロード
 */
export const getFilesZip = (params: string) => {
  const url = `/api/v1/get/files/zip?file_ids_csv=${params}`;
  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * ファイルの単一ダウンロード
 */
export const getFileDownload = (file_id: string, actionLog: boolean) => {
  const url = `/api/v1/get/file/${file_id}?action_log=${actionLog}`;
  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真のzipダウンロード
 */
export const getPicturesZip = (params: string) => {
  const url = `/api/v1/get/pictures/zip?picture_ids_csv=${params}`;
  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真の単一ダウンロード
 */
export const getPictureDownload = (picture_id: string) => {
  const url = `/api/v1/get/picture/${picture_id}`;
  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * ファイル移動
 */
export const moveFolderFile = (fileId: number, folderId: number) => {
  const url = `/api/v1/move/file/${fileId}/${folderId}`;
  return axios
    .put(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真移動
 */
export const moveFolderPicture = (pictureId: number, folderId: number) => {
  const url = `/api/v1/move/picture/${pictureId}/${folderId}`;
  return axios
    .put(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
